/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Activities } from 'services/actions/activities';
import { ActivityListOptions } from 'services/activity_list';
import Select from 'react-select';
import { Container } from './styles';

interface Activity {
  id: string;
  atividade: string;
  nome: string;
}

interface ModalActivitiesProps {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showModal: boolean;
  descricaoAtividades: string;
  setDescricaoAtividades: React.Dispatch<React.SetStateAction<string>>;
  setAtividadesName: React.Dispatch<React.SetStateAction<string>>;
  setAtividadesIds: React.Dispatch<React.SetStateAction<string[]>>;
}

const ModalActivities = (props: ModalActivitiesProps) => {
  const {
    setShowModal,
    showModal,
    descricaoAtividades,
    setDescricaoAtividades,
    setAtividadesName,
    setAtividadesIds,
  } = props;

  const [atividades, setAtividades] = useState<Activity[]>([]);
  const [atividadesSelecionadas, setAtividadesSelecionadas] = useState<Activity[]>([]);

  const adicionarAtividade = () => {
    const atividadeNome = atividadesSelecionadas.map((atividade) => atividade.nome).join(', ');
    const atividadeID = atividadesSelecionadas.map((atividade) => atividade.id.toString());
    setAtividadesName(atividadeNome);
    setAtividadesIds(atividadeID);
    setShowModal(false);
  };

  const handleSegmentChange = async (selected: any) => {
    const segmentoSelecionado = selected.value;
    const response = await Activities(segmentoSelecionado);
    setAtividades(response);
  };

  const handleCheckboxChange = (selectedActivity: Activity) => {
    const isAlreadySelected = atividadesSelecionadas.some(
      (atividade) => atividade.id === selectedActivity.id,
    );
    if (isAlreadySelected) {
      setAtividadesSelecionadas(
        atividadesSelecionadas.filter((atividade) => atividade.id !== selectedActivity.id),
      );
    } else {
      setAtividadesSelecionadas([...atividadesSelecionadas, selectedActivity]);
    }
  };

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
      <Container>
        <div>
          <div
            id="modal_activities"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Adicione atividades
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setShowModal(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p className="text-left">
                    Selecione um segmento e aguarde carregar as atividades{' '}
                  </p>
                  <form>
                    <div className="form-group">
                      <Select
                        name=""
                        closeMenuOnSelect
                        options={ActivityListOptions}
                        placeholder="Selecione o segmento"
                        onChange={handleSegmentChange}
                      />
                    </div>
                    {atividades?.map((atividade: any) => (
                      <div key={atividade?.id} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={atividade?.id}
                          id={`atividade-${atividade?.id}`}
                          onChange={() => handleCheckboxChange(atividade)}
                          checked={atividadesSelecionadas?.some(
                            (ativ) => ativ?.id === atividade?.id,
                          )}
                        />
                        <label className="form-check-label" htmlFor={`atividade-${atividade?.id}`}>
                          {atividade?.nome}
                        </label>
                      </div>
                    ))}
                    <hr />
                    <div className="data-api"> </div>
                  </form>
                </div>
                <div className="p-3">
                  <div className="form-group mt-3">
                    <label htmlFor="message-text" className="col-form-label">
                      Se desejar, descreva detalhadamente as atividades da sua empresa:
                    </label>
                    <textarea
                      className="form-control"
                      id="descricaoAtividades"
                      name="described[activities]"
                      value={descricaoAtividades}
                      form="cadastro"
                      onChange={(event) => setDescricaoAtividades(event.target.value)}
                    />
                  </div>
                  <button
                    type="button"
                    id="adicionar_atividade"
                    className="btn btn-success btn-lg btn-block"
                    onClick={adicionarAtividade}
                  >
                    Adicionar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalActivities;
